<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="关键字" name='product_name'>
      <a-input v-model:value="search.product_name" :style="{width:'300px'}" placeholder="请输入关键词进行搜索" />
    </a-form-item>
    <!-- <a-form-item label="商品分类" name='type_id'>
      <a-select v-model:value="search.type_id" :style="{width:'140px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option value="shanghai">正常</a-select-option>
        <a-select-option value="beijing">禁用</a-select-option>
      </a-select>
    </a-form-item> -->
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
    <template v-slot:info="{record}">
      <a-card-meta>
        <template #avatar>
          <img :src="info.picdomain+'/'+(record.product_image||record.cover_image_url)" alt="" style="width:50px;height: 50px;object-fit:cover">
        </template>
        <template #description>
          <p>{{record.product_name}}</p>
          <p>({{record.sku_name?record.sku_name:'单规格'}})</p>
        </template>
      </a-card-meta>
    </template>
    <template v-slot:action="{ record }">
        <a-button type="primary" class="m-b-5" @click='checkBnt(record,"select")' :ghost="!record.select" :disabled="record.selectDisabled">{{!record.select ? "选择单件":"已选择单件"}}
        </a-button>
        <a-button type="primary" @click='checkBnt(record,"boxSelect")' :ghost="!record.boxSelect" :disabled="record.boxSelectDisabled">{{!record.boxSelect ? "选择整箱":"已选择整箱"}}
        </a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
  <div class="s_flex_center m-t-25" v-if='checkout'>
    <a-button type="primary" @click='confirm'>确定</a-button>
  </div>
</template>

<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getProductSkuList } from "@/api/online";
import { iscode } from "@/utils/app";
import store from "@/store";
// 初始化默认筛选项数值
let defSearch = {
  product_name: "",
  page: 1,
  limit: 5,
};
export default {
  name: "selectOnlineSkuGoods",
  components: {},
  props: {
    selectList: {
      type: Array,
    },
    beSelectGoodsKeys: {
      type: Object || Boolean,
      default: () => {
        return false;
      },
    },
    checkout: {
      type: Boolean,
    },
    selectLimit: {
      type: Number,
    },
    selectBox:{
      type:Boolean,
      default:()=>{
        return true
      }
    }
  },
  setup(props, { emit }) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      info: store.state.user.info,
      listLoading: false,
      total: 1,
      selectList: [],
      checkout: false,
    });
    let columns = [
      {
        title: "商品名称",
        dataIndex: "info",
        key: "info",
        slots: { customRender: "info" },
      },
      {
        title: "规格",
        dataIndex: "sku_name",
        key: "sku_name",
        customRender: ({ record }) => {
          return record.sku_name || "单规格";
        },
      },
      {
        title: "商品分组",
        dataIndex: "category_name",
        key: "category_name",
      },
      {
        title: "价格/元",
        dataIndex: "product_price",
        key: "product_price",
      },
      {
        title: "操作",
        key: "action",
        width: 120,
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    const _lodash = inject("_lodash");

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    //单选
    const select = (e) => {
      data.value.map((item) => (item.select = false));
      e.select = !e.select;
      emit("select", e);
    };
    //多选
    const checkBnt = (e, type) => {
      if (props.selectLimit && state.selectList.length == 5 && !e.select) {
        message.error("最多只能选择" + props.selectLimit + "个商品");
        return;
      }
      if (!e[type]) {
        state.selectList.push({ ...e, key: type == "select" ? 0 : 1 });
      } else {
        // state.selectList
        var index = -1;
        state.selectList.forEach((v, k) => {
          if (
            v.goods_id == e.goods_id &&
            ((type == "select" && v.key == 0) ||
              (type == "boxSelect" && v.key == 1))
          ) {
            index = k;
          }
        });
        if (index != -1) {
          state.selectList.splice(index, 1);
        }
      }
      e[type] = !e[type];
    };
    //多选确认
    const confirm = () => {
      emit("select", state.selectList);
    };
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getProductSkuList(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data;
          state.total = res.meta.total;
          var keys = [];
          if (props.beSelectGoodsKeys) {
            keys = Object.keys(props.beSelectGoodsKeys);
          }
          data.value.forEach((i) => {
            if (state.selectList.length > 0) {
              const goods = state.selectList.map((v) =>
                i.goods_id == v.goods_id && i.sku_id == v.sku_id ? v : false
              );
              if (goods.length) {
                goods.forEach((e) => {
                  console.log(e, "e");
                  console.log(i, "i");
                  if (keys.length) {
                    keys.forEach((v) => {
                      var falg = v.split("-");
                      falg.shift();
                      falg = falg.join("-");
                      // 结果为 goodsid-skuid-单件0
                      if (i.goods_id + "-" + i.sku_id + "-0" == falg) {
                        i.selectDisabled = true;
                      }
                      if (i.goods_id + "-" + i.sku_id + "-1" == falg) {
                        i.boxSelectDisabled = true;
                      }
                    });
                  }
                  if (e.key == 0) {
                    i.select = true;
                  }
                  if (e.key == 1) {
                    i.boxSelect = true;
                  }
                });
              } else {
                i.select = false;
                i.boxSelect = false;
              }
            } else {
              keys.forEach((v) => {
                var falg = v.split("-");
                falg.shift();
                falg = falg.join("-");
                // 结果为 goodsid-skuid-单件0
                if (i.goods_id + "-" + i.sku_id + "-0" == falg) {
                  i.selectDisabled = true;
                }
                if (i.goods_id + "-" + i.sku_id + "-1" == falg) {
                  i.boxSelectDisabled = true;
                }
              });
            }
          });
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    onMounted(() => {
      if (props.selectList) {
        state.selectList = props.selectList;
      }
      initData(search.value);
    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      select,
      checkBnt,
      confirm,
    };
  },
};
</script>